<template>
  <div class="drawer-scroll">
    <div class="flex-container align-top">
      <div class="flex-item">
        <p v-for="(lrNumber,index) in lrNumberDetails" :key="index">
          <span class="text-grey-light1">{{lrNumber.title}}:</span>
          <strong class="text-bold">
            <span v-if="lrNumber.lr_number">{{lrNumber.lr_number}}</span>
            <span v-else>-</span>
          </strong>
        </p>
      </div>
      <div class="flex-item text-right ml-auto mt-40" v-if="hasAttachments">
        <Popover
          v-if="isLRRejectEnable"
          v-model:visible="isPopoverVisible"
          placement="bottom-end"
          width="400"
          :visible-arrow="false"
          popper-class="popover-dark mt-m20 px-20 pb-20">

          <div class="popover-wrapper mb-10">
            <h4 class="text-grey_lighter10 text-md pt-10">{{ $t('REJECT_DOCUMENT') }}
              <i class="text-grey-medium f-right pointer" @click="closePopover">
                <svgicon name="icon-close" width="8" height="8" />
              </i>
            </h4>
            <div class="text-grey_lighter10 text-sm mb-5">{{ $t('SELECT_FOR_DOCUMENT_REASON') }}</div>
              <div class="flex-center mb-10">
                <div class="text-sm text-grey_lighter10 wp-40">{{  $t('SELECT_REASON') }}</div>
                <Select
                  align="right"
                  size="mini"
                  clearable
                  v-model="lrRejectedReason.data"
                  @change="lrRejectedReason.custom = ''"
                  popper-class="select-dark-dropdown text-right"
                  class="select-default select-dark">
                  <Option
                    v-for="item in reasonList"
                    :key="item.key"
                    :value="item.value">
                    <!-- <Ellipsis
                      :text="item.value"
                      :length="50"
                    /> -->
                  </Option>
                </Select>
              </div>
              <div v-if="lrRejectedReason.data === 'OTHERS'" class="comment-block mb-10 ">
                <div for="comment" class="text-grey_lighter10 p-10 pb-0 text-sm">{{ $t('INDENT_COMMENTS') }}</div>
                <textarea
                v-model="lrRejectedReason.custom"
                id="comment"
                rows="4"
                :placeholder="$t('INDENT_ENTER_REASON')"
                >
              </textarea>
              </div>
              <div class="f-right">
                <Button type="dark" size="mini" @click="closePopover">Cancel</Button>
                <Button type="dark" size="mini" class="text-red"
                  :class="{'is-disabled': !isRejectDisable}"
                 @click="rejectAttachments(file)">Reject</Button>
              </div>
          </div>
          <span slot="reference">
              <Button type="dark" class="text-red mr-10" size="mini">Reject</Button>
          </span>
        </Popover>
        <span class="text-white">
          <svgicon
            name="icon-expand-xl"
            class="pointer"
            width="20"
            height="20"
            @click="handlePictureCardPreview(selectedAttachment);$emit('setGA','Expand Icon')" />
          <svgicon
            name="icon-download-xl"
            class="pointer ml-20"
            @click="handleDownload(selectedAttachment);$emit('setGA','Download Icon')"
            width="20"
            height="20"/>
        </span>
      </div>
    </div>
    <div class="clearfix mt-15">
      <div class="preview-upload" v-if="hasAttachments">
        <img :src="selectedImageSrc" alt="" />
      </div>
      <div :class="{'disableUpload': disableUpload}">
        <Upload
          action
          list-type="picture-card"
          :file-list="getAttachments"
          :limit="maxAllowed"
          :multiple="multiple"
          :auto-upload="false"
          :on-exceed="handleExceed"
          :on-change="addAttachment"
          :disabled="disableUpload"
          class="default-upload flex-reverse dark"
          :class="{'is-disabled':disableUpload}">
          <i class="el-icon-plus" @click="$emit('setGA','Add Attachment Icon')"></i>
          <div class="el-upload-list__item-slot" slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="setIcon(file)" alt="" />
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="previewAttachment(file); $emit('previewFile', file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <Popconfirm title="Are you sure to delete the attachment?" @confirm="removeAttachment(file)">
                <span slot="reference"
                  v-if="!disableUpload && !disableDelete && !isLRRejectEnable"
                  class="el-upload-list__item-delete">
                  <i class="el-icon-delete"></i>
                </span>
              </Popconfirm>
            </span>
            <div v-if="file.name" class="filenametag">{{ file.name }}</div>
          </div>
        </Upload>
        <a class="download-file" />
        <Dialog :visible.sync="dialogVisible"
          width="80%"
          :append-to-body="true"
          :close-on-click-modal="false"
          :fullscreen="true"
          :show-close="false"
          custom-class="preview-popup">
        <div class="preview-header text-right">
        <span class="actions" style="margin-right: 20px;">
          <svgicon
          name="rotate-left"
          class="pointer"
          width="20"
          height="20"
          @click="rotateLeft" />
           <svgicon
          name="rotate-right"
          class="pointer ml-20"
          width="20"
          height="20"
          @click="rotateRight" />
          <svgicon
            name="cancelnocolor"
            class="pointer ml-20"
            width="20"
            height="20"
            @click="dialogVisible = false" />
          </span>
    </div>
    <div class="preview-body">
      <Dialog :visible.sync="dialogVisible" :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out`">
      <img width="100%" :src="selectedImageSrc" alt=""/>
      </Dialog>
    </div>
        </Dialog>
      </div>
    </div>
    <div class="summary-preview">
      <div class="preview-content">
        <ul>
          <li v-for="(item, index) in getAttachments" v-if="item.summary && item.summary.document_summary" :key="index">
            <!--            <h4>Document {{ index + 1}} Summary</h4>-->
            <vue-markdown :source="cleanUpMarkdown(item.summary.document_summary.extracted_data_markdown || item.summary.document_summary.summary)"/>
            <!--            <p>{{item.summary.document_summary.summary}}</p></li>-->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import AttachmentConstants from "@common/constants/AttachmentConstants";
import UploadMixin from "@common/mixins/UploadMixin";
import VueMarkdown from 'vue-markdown'
export default {
  components: {
    VueMarkdown,
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    disableUpload: {
      type: Boolean,
      default: false
    },
    disableDelete: {
      type: Boolean,
      default: false
    },
    lrNumberDetails: {
      type: Array,
      default: () => []
    },
    disableUpload: {
      type: Boolean,
      default: false,
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
    maxAllowed: {
      type: Number,
      default: 5,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    orderDetails: {
      type: Object,
      default: {},
    },
    viewLrSummary: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      comment: '',
      reasonList: [],
      lrRejectedReason: {
        custom: '',
        data: '',
      },
        value: '',
        isPopoverVisible: false,
    };
  },
  mixins: [UploadMixin],
  created() {
    this.selectedAttachmentIndex = 0;
    if (!this.viewOnly) this.getLRRejectionReason();
  },
  computed: {
    showSummary() {
      return this.attachments.some((attachment) => attachment && attachment.summary);
    },
    getAttachments() {
      return this.attachments;
    },
    hasAttachments() {
      return this.attachments && this.attachments.length;
    },
    isLRRejectEnable(){
      if (this.viewOnly) return false;
      return (this.$hasPermission('lr_attchment_rejection') && this.$hasFeature('lr_attchment_rejection'))
    },
    isRejectDisable(){
      return (this.lrRejectedReason.data || this.lrRejectedReason.custom)
    }
  },
  methods: {
    cleanUpMarkdown(rawMarkdown) {
      if (typeof rawMarkdown !== 'string') {
        console.error('Expected string input but got:', typeof rawMarkdown)
        return ''
      }
      return rawMarkdown
        .replace(/(['"])\s*\+\s*\1/g, '')
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '\r')
        .replace(/\\t/g, '\t')
        .trim()
    },
    async getLRRejectionReason(){
      let depotId;
        if (this.orderDetails && [1, 2].includes(this.orderDetails.movement)) { // TODO: Use constants
          depotId = this.orderDetails.sources && this.orderDetails.sources[0]
            && this.orderDetails.sources[0].location_id;
        } else {
          depotId = this.orderDetails.destinations && this.orderDetails.destinations[0]
            && this.orderDetails.destinations[0].location_id;
        }
      const payload = {
          type: 'LR_ATTACHMENT_REJECTION',
          movement: this.orderDetails && this.orderDetails.movement,
          depot_id: depotId,
        };
        const result = await this.$store.dispatch('settings/getReasonSettings', payload);
        if (result && result.data && result.data.length) {
          const configReasons = result.data.map(item => ({
            key: item,
            value: item,
          }));
          this.reasonList = [
            ...configReasons,
            {
              value: 'OTHERS',
              key: 'OTHERS',
            },
          ];
        } else {
          this.reasonList = [
            {
              value: 'OTHERS',
              key: 'OTHERS',
            },
          ];
        }
    },
    async rejectAttachments(){
      const file = this.attachments[this.selectedAttachmentIndex];
        let reason = this.lrRejectedReason.data === 'OTHERS' ? this.lrRejectedReason.custom : this.lrRejectedReason.data;
      const rejectedData = {
        attachmentId: file.id,
        lrRejectedReason: reason
      }
      this.$emit('rejectAttachments',rejectedData);
      this.selectedAttachmentIndex = 0;
      this.closePopover();
    },
    removeAttachment(file) {
      this.$emit("removeAttachments", file);
      this.selectedAttachmentIndex = 0;
    },
    togglePopover() {
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    closePopover() {
      this.isPopoverVisible = false;
      this.lrRejectedReason = {
        data: '',
        custom: ''
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.preview {
  &-title {
    padding: 13px 0 14px 10px;
    display: block;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    background: #343440;
    margin-top: 15px;
    border-radius: 20px 5px 5px 20px;
    text-transform: capitalize !important;

    .gradient-text-sucess {
      font-size: 14px;
      background: linear-gradient(360deg, #006265 -62.07%, #19A476 104.14%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    span {
      display: block;
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 0.7px;

      &.text-white {
        font-size: 12px !important;
        text-transform: capitalize !important;
      }
    }

    .agent-title{
      font-size: 10px;
      padding-right: 10px;
      color: #FEE018;
    }
  }

  &-content {
    padding: 1px 10px;
    border-radius: 10px;

    h4 {
      color: #dfdede;
      text-transform: uppercase;
      font-weight: 800;
      letter-spacing: 0.3px;
      font-size: 10px;
      margin-top: 20px;
    }

    p {
      line-height: 16px;
      font-size: 11px;
      //color: #d2d4dd;
    }

    li {
      border-bottom: 0.5px solid #646468;
    }
  }

}
</style>
<style lang="scss">
.preview-content {
  h1, h2, h3, h4 {
    color: #fff;
    font-size: 13px;
    margin-bottom: 5px;
  }

  ul {
    color: #fff;
    margin-bottom: 15px;

    li {
      color: #d0d5d7 !important;
      font-size: 12px !important;
      line-height: 20px;

      &::marker {
        content: '• ';
        color: black;
        font-weight: bold;
      }
    }

    p {
      color: #d0d5d7 !important;
      font-size: 12px !important;
      line-height: 20px;
    }
  }
}
</style>
